import { useEffect } from 'react'
import { Card } from '@/components/ui/card'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { fetchMyUsageStats } from '@/redux/asyncThunks/usageStats'

type PlayerUsageSummaryCardProps = {
  roomId: string
}

const PlayerUsageSummaryCard = ({ roomId }: PlayerUsageSummaryCardProps) => {
  const dispatch = useAppDispatch()
  const {
    myStats,
    myTotalRounds,
    isLoadingMine,
    error: usageError,
  } = useAppSelector((state) => state.usageStats)

  useEffect(() => {
    if (!roomId) return
    dispatch(fetchMyUsageStats(roomId))
  }, [dispatch, roomId])

  return (
    <Card className='mx-2 mt-2 p-4 border border-slate-200'>
      <div className='flex items-center justify-between gap-3'>
        <div>
          <h3 className='font-semibold text-dark-blue'>Usage Summary</h3>
          <p className='text-xs text-slate-500'>
            Your overall activity in this game.
          </p>
        </div>
      </div>

      {isLoadingMine && (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-3 text-sm animate-pulse'>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className='h-4 bg-slate-200 rounded w-3/4' />
          ))}
        </div>
      )}

      {!isLoadingMine && usageError && (
        <p className='mt-3 text-sm text-red-600' role='alert'>
          {usageError}
        </p>
      )}

      {!isLoadingMine && !usageError && !myStats && (
        <p className='mt-3 text-sm text-slate-500'>
          No usage data available for this room.
        </p>
      )}

      {!isLoadingMine && !usageError && myStats && (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-3 text-sm'>
          <p>Time Spent: {myStats.time_spent_minutes} minutes</p>
          <p>Rounds Completed: {myTotalRounds ?? '-'}</p>
          <p>Total Advisor Messages: {myStats.advisor_messages}</p>
          <p>Total Negotiation Messages: {myStats.negotiation_messages}</p>
          <p>Decisions: {myStats.decisions_made}</p>
        </div>
      )}
    </Card>
  )
}

export default PlayerUsageSummaryCard
